import React from 'react';
import PropTypes from 'prop-types';
import { addDaysToDate, formatDateRange, formatDateKey } from './dateUtils';
import style from './CalendarSidebar.module.sass';

// Left-hand sidebar: holds the "Job Calendar" title, week navigation,
// the date picker, the Change Log button, and the Seniors-only filter.
// Moving these controls off the top frees the entire vertical area for
// the day columns so more jobs are visible per day.
const CalendarSidebar = ({
  startDate,
  onPrevious,
  onNext,
  onToday,
  onDatePick,
  onShowChangeLog,
  seniorsOnly,
  onToggleSeniors,
  oneWeekOnly,
  onToggleOneWeek,
}) => {
  // Mon-Sun: 6 days past Monday for one week, 13 for two — matches the rendered grid.
  const endDate = addDaysToDate(startDate, oneWeekOnly ? 6 : 13);

  const handleDateChange = (e) => {
    const date = new Date(`${e.target.value}T00:00:00`);
    if (!Number.isNaN(date.getTime())) onDatePick(date);
  };

  return (
    <div className={style.sidebar}>
      <h2 className={style.title}>Job Calendar</h2>

      <div className={style.dateRange}>
        {formatDateRange(startDate, endDate)}
      </div>

      <div className={style.navGroup}>
        <button type="button" className={style.navButton} onClick={onPrevious}>
          &larr; Previous Week
        </button>
        <button type="button" className={style.todayButton} onClick={onToday}>
          Today
        </button>
        <button type="button" className={style.navButton} onClick={onNext}>
          Next Week &rarr;
        </button>
      </div>

      <label className={style.fieldLabel}>
        Jump to week
        <input
          type="date"
          className={style.datePicker}
          value={formatDateKey(startDate)}
          onChange={handleDateChange}
        />
      </label>

      <label className={style.checkboxRow}>
        <input
          type="checkbox"
          checked={seniorsOnly}
          onChange={onToggleSeniors}
        />
        <span>Seniors only (S0&hellip;)</span>
      </label>

      <label className={style.checkboxRow}>
        <input
          type="checkbox"
          checked={oneWeekOnly}
          onChange={onToggleOneWeek}
        />
        <span>One week only</span>
      </label>

      <button type="button" className={style.changeLogButton} onClick={onShowChangeLog}>
        Change Log
      </button>
    </div>
  );
};

CalendarSidebar.propTypes = {
  startDate: PropTypes.instanceOf(Date).isRequired,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onToday: PropTypes.func.isRequired,
  onDatePick: PropTypes.func.isRequired,
  onShowChangeLog: PropTypes.func.isRequired,
  seniorsOnly: PropTypes.bool.isRequired,
  onToggleSeniors: PropTypes.func.isRequired,
  oneWeekOnly: PropTypes.bool.isRequired,
  onToggleOneWeek: PropTypes.func.isRequired,
};

export default CalendarSidebar;
